import {ERROR} from './const'

const url = 
  { 
    jini: 'http://35.224.70.129/query'
  }


// FOR OPENAI
const predict = {
  openai: async function(prompt) {

    const body = {
      instruction:'openai',
      payload: {prompt:prompt},
    }
    
    try {
      const response = await fetch(url.jini, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      /// TODO: check the open AI returned fields

      const result = {
        error: data.error,
        payload: data?.payload?.choices[0]?.message?.content
      }
      return result;

    } catch (error) {
      console.error('Error:', error);
      return Promise.resolve({error:ERROR.fatal, payload:error});
    }
  },    

  vertex: async function(prompt) {

    const body = {
      instruction:'predict',
      payload: {prompt:prompt},
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      return data;

    } catch (error) {
      console.error('Error:', error);
      return Promise.resolve({error:ERROR.fatal, payload:error});
    }
  }
}

export {
    predict
}
